import React, { useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const DisclaimerPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-12 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-14 h-14 bg-amber-100 rounded-xl flex items-center justify-center">
              <AlertTriangle className="w-7 h-7 text-amber-600" />
            </div>
            <div>
              <h1 className="text-3xl sm:text-4xl font-bold text-slate-800">Disclaimer</h1>
              <p className="text-slate-500">G&B Wood</p>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate max-w-none">
            
            <div className="bg-slate-50 rounded-xl p-8">
              <p className="text-slate-600 leading-relaxed mb-6">
                Le informazioni presenti su questo sito hanno scopo puramente informativo e illustrativo dei servizi offerti da G&B Wood.
              </p>

              <p className="text-slate-600 leading-relaxed mb-6">
                Non costituiscono in alcun modo preventivo vincolante o offerta contrattuale.
              </p>

              <p className="text-slate-600 leading-relaxed mb-6">
                Caratteristiche, prezzi e modalità di esecuzione dei lavori vengono definiti esclusivamente a seguito di contatto diretto e sopralluogo, ove necessario.
              </p>

              <p className="text-slate-600 leading-relaxed">
                G&B Wood si riserva il diritto di modificare in qualsiasi momento contenuti, immagini e informazioni presenti sul sito, senza preavviso.
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DisclaimerPage;
